/* Built In Imports */
/* External Imports */
import { Box } from '@chakra-ui/react';
import { nanoid } from 'nanoid';

/* Internal Imports */
/* Component */
import SectionUI from '@components/UI/Common/SectionUI';

/* Services  */
/* Styles */

/**
 * Renders LearnSection Component
 * @param {Object} sectionContent - data for the section from api
 * @param {string} region - Region of the section
 * @param {string} lang - Language of the section
 */
const LearnSection = ({ sectionContent, lang, region }) => {
  return (
    <Box w="full" p="30px 0">
      {sectionContent && sectionContent.length
        ? sectionContent.map(section => {     
            return (
              <SectionUI
                key={nanoid(4)}
                sectionContent={section}
                region={region}
                language={lang}
              />
            );
          })
        : null}
    </Box>
  );
};

export default LearnSection;
